var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useTheme } from "../hooks/useTheme";
import { LibIcon } from './components';
export var Subtract = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 32 : _b, _c = _a.lss, lss = _c === void 0 ? { color: 'gray300' } : _c, _d = _a.title, title = _d === void 0 ? '' : _d, props = __rest(_a, ["size", "lss", "title"]);
    var theme = useTheme();
    return (React.createElement("svg", __assign({ width: size, height: size, viewBox: "0 0 32 32" }, props),
        title && React.createElement("title", null, title),
        React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "9", transform: "translate(-1281.000000, -266.000000)", fill: theme.colors[lss.color], fillRule: "nonzero" },
                React.createElement("path", { d: "M1297,266 C1288.168,266 1281,273.168 1281,282 C1281,290.832 1288.168,298 1297,298 C1305.832,298 1313,290.832 1313,282 C1313,273.168 1305.832,266 1297,266 Z M1301,282.85 L1297.8,282.85 L1296.2,282.85 L1293,282.85 L1293,281.25 L1296.2,281.25 L1297.8,281.25 L1301,281.25 L1301,282.85 Z", id: "Shape", style: { mixBlendMode: 'multiply' } })))));
};
export var SubtractIcon = function (props) { return (React.createElement(LibIcon, __assign({ icon: Subtract }, props))); };
//# sourceMappingURL=SubtractIcon.js.map